import React from 'react';
import _ from 'lodash';

export default function LeftPanel(props) {
  const data = props && props.data;
  const onClickFunc = props && props.onClickFunc;
  let countList = [0, 0];

  if (data && data.orderCountToStts) {
    const _countArr = data.orderCountToStts;

    // 접수대기('3') 및 처리중('4') 상태를 하나로 묶어 합산
    const activeOrders = _.filter(_countArr, (o) => ['3', '4'].includes(o.ordrStts));
    countList[0] = _.sumBy(activeOrders, 'count');

    // 완료 상태 합산
    const completedOrders = _.reject(_countArr, (o) => ['0', '3', '4', 'C'].includes(o.ordrStts));
    countList[1] = _.sumBy(completedOrders, 'count');
    
    
    
    
    // const _countArr = data.orderCountToStts;
    // countList[0] = _.find(_countArr, { ordrStts: '3' })?.count || 0; // 접수대기 Count
    // countList[1] = _.find(_countArr, { ordrStts: '4' })?.count || 0; // 처리중 Count
    // countList[2] = 0;
    // const completedArr = _.reject(_countArr, function (o) {
    //   return o.ordrStts === '0' || o.ordrStts === '3' || o.ordrStts === '4' || o.ordrStts === 'C';
    // });
    // for (let i = 0; i < completedArr.length; i++) {
    //   countList[2] += completedArr[i].count;
    // }
  }

  const renderItem = (v, i) => {
    let caption = ['접수', '완료'];
    
    // 모바일에서는 가로 분할(border-r), PC에서는 세로 분할(border-t)
    const isSelected = props.active === i;
    const bgClass = isSelected ? 'bg-cust-gray font-bold' : 'bg-cust-medium-gray text-gray-700';
    const borderClass = i === 0 ? '' : 'border-l md:border-l-0 md:border-t';

    return (
      <div 
        className={`flex-1 flex flex-col justify-center items-center ${bgClass} ${borderClass} border-cust-line transition-colors duration-150 relative`} 
        key={`key-${i}`}
      >
        <button
          className="w-full h-full py-2 md:py-0 flex flex-col justify-center items-center focus:outline-none"
          onClick={async () => {
            if (onClickFunc) await onClickFunc(`${i + 3}`);
          }}
        >
          <div className="inline-flex flex-col justify-center items-center transition duration-150 ease-in-out transform hover:scale-105">
            {/* NEW 배지: 모바일에서는 절대 좌표로 상단에 띄우거나 콤팩트하게 표시 */}
            {i === 0 && countList[0] !== 0 ? (
              <div className="inline-flex justify-center items-center rounded-full px-1.5 py-px text-[9px] sm:px-2 sm:py-0.5 sm:text-xs text-white bg-primary mb-1">
                NEW
              </div>
            ) : null}
            
            <span className="text-xs sm:text-sm md:text-base font-bold whitespace-nowrap">{caption[i]}</span>
            <span className="text-sm sm:text-base md:text-lg font-bold mt-0.5">{v}</span>
          </div>
        </button>
      </div>
    );
  };

  return (
    <div className="flex flex-row md:flex-col w-full md:w-28 lg:w-32 h-16 md:h-full shrink-0 border-b md:border-b-0 md:border-r border-cust-line select-none">
      {countList.map(renderItem)}
    </div>
  );
}